<div class="flex-full-screen">
  <ngx-loading class="global-busy" [show]="busy?.show" [text]="busy?.text"></ngx-loading>

  <p-toast class="toast-global"
    key="global"
    position="top-center"
    [preventOpenDuplicates]="true">
    <ng-template #message let-message>
      <div
        style="display: contents;">
        @switch (message.data?.type) {
          @case ('genericErrorMessage') {
            <div
              class="message-with-link flex-1 flex-row gap-1">
              <span class="p-toast-message-icon fas fa-sync-alt">
              </span>
              <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ message.summary }}</div>
                <div class="p-toast-detail">{{ 'Something went wrong. If the problem persists, please' }} <a href="https://help.miradishare.org/hc/en-us/requests/new" target="_blank">{{ 'contact Miradi support' }}</a>.</div>
              </div>
            </div>
          }
          @case ('projectEditStatus') {
            <div
              class="message-with-link flex-1 flex-row gap-1">
              <span class="p-toast-message-icon fas fa-sync-alt">
              </span>
              <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ message.summary }}</div>
                <a href="javascript: void(0);" (click)="refreshProject()">{{ message.detail }}</a>
              </div>
            </div>
          }
          @case ('E00127') {
            <div
              class="message-with-link flex-1 flex-row gap-1">
              <span class="p-toast-message-icon pi pi-info-circle">
              </span>
              <div class="p-toast-message-text">
                <div class="p-toast-detail">{{ 'It looks like you are trying to move an indicator to a target that is currently in KEA mode. In order to do so, please move the indicator to the correct KEA under that target instead.' | translate }} <a href="https://help.miradishare.org/hc/en-us/articles/11080665359387-2023-1-2022-Year-in-Review#h_01GKSJ09PBWFG0GEFB8N60N8P4" target="_blank">{{ 'Learn more about copying and moving content in Miradi Share' | translate }}&nbsp;<i class="fas fa-external-link-alt icon-external-link"></i></a></div>
              </div>
            </div>
          }
          @case ('E00184') {
            <div
              class="message-with-link flex-1 flex-row gap-1">
              <span class="p-toast-message-icon far fa-circle-xmark">
              </span>
              <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ 'Cannot change FY timeframe' | translate }}</div>
                <div class="p-toast-detail">{{ 'There is yearly work plan data that would overlap with lower-level data if the fiscal year timeframe changed.' }} <a href="https://help.miradishare.org/hc/en-us/articles/37697260211739" target="_blank">{{ 'Help on solving this' }}&nbsp;<i class="fas fa-external-link-alt icon-external-link"></i></a></div>
              </div>
            </div>
          }
          @default {
            <div
              class="flex-1 flex-row gap-1">
              <span [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')"
            [ngClass]="{'pi-info-circle': message.severity == 'info', 'pi-exclamation-triangle': message.severity == 'warn',
            'pi-times-circle': message.severity == 'error', 'pi-check' :message.severity == 'success'}">
              </span>
              <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ message.summary }}</div>
                <div class="p-toast-detail">{{ message.detail }}</div>
              </div>
            </div>
          }
        }
      </div>
    </ng-template>
  </p-toast>

  <div class="body">
    <miradi-maintenance-banner></miradi-maintenance-banner>
    <miradi-eula-banner [hidden]="(currentPageUrl || '').indexOf('/account-setup') >= 0"></miradi-eula-banner>
    <miradi-subscription-nudge-banner [hidden]="(currentPageUrl || '').indexOf('/account-setup') >= 0"></miradi-subscription-nudge-banner>
    <miradi-survey-banner></miradi-survey-banner>
    <router-outlet></router-outlet>
  </div>
</div>

<miradi-info-dialog></miradi-info-dialog>

<miradi-session-expired-dialog></miradi-session-expired-dialog>

<div id="plugin-scripts"></div>


